import { useTranslation } from 'react-i18next';

export default function SocialProof() {
  const { t } = useTranslation();
  
  const metrics = [
    {
      value: t('socialProof.metrics.responseTime.value'),
      label: t('socialProof.metrics.responseTime.label'),
      description: t('socialProof.metrics.responseTime.description'),
      icon: 'ri-timer-flash-fill',
      color: 'from-purple-500 to-pink-500'
    },
    {
      value: t('socialProof.metrics.sales.value'),
      label: t('socialProof.metrics.sales.label'),
      description: t('socialProof.metrics.sales.description'),
      icon: 'ri-line-chart-fill',
      color: 'from-green-500 to-emerald-500'
    },
    {
      value: t('socialProof.metrics.leads.value'),
      label: t('socialProof.metrics.leads.label'),
      description: t('socialProof.metrics.leads.description'),
      icon: 'ri-user-star-fill',
      color: 'from-blue-500 to-cyan-500'
    },
    {
      value: t('socialProof.metrics.responseRate.value'),
      label: t('socialProof.metrics.responseRate.label'),
      description: t('socialProof.metrics.responseRate.description'),
      icon: 'ri-checkbox-circle-fill',
      color: 'from-orange-500 to-red-500'
    }
  ];

  return (
    <section className="py-24 px-6 bg-gradient-to-b from-gray-900 to-gray-950 relative overflow-hidden">
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-40 right-20 w-96 h-96 bg-purple-500 rounded-full blur-3xl"></div>
        <div className="absolute bottom-40 left-20 w-96 h-96 bg-green-500 rounded-full blur-3xl"></div>
      </div>

      <div className="max-w-7xl mx-auto relative z-10">
        <div className="text-center mb-20">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-green-500/10 border border-green-500/30 rounded-full mb-6">
            <i className="ri-trophy-fill text-green-400"></i>
            <span className="text-green-300 text-sm font-medium">{t('socialProof.badge')}</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            {t('socialProof.title')}
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto">
            {t('socialProof.subtitle')}
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-20">
          {metrics.map((metric, index) => (
            <div 
              key={index}
              className="group relative bg-gray-950/50 backdrop-blur-sm border border-gray-800 rounded-2xl p-8 hover:border-gray-700 transition-all duration-300 hover:scale-105 cursor-pointer text-center"
            >
              <div className="absolute inset-0 bg-gradient-to-br from-gray-800/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-2xl"></div>
              
              <div className="relative z-10">
                <div className={`w-16 h-16 flex items-center justify-center rounded-xl bg-gradient-to-br ${metric.color} mb-6 mx-auto group-hover:scale-110 transition-transform duration-300`}>
                  <i className={`${metric.icon} text-3xl text-white`}></i>
                </div>
                
                <div className="text-5xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-purple-400 to-green-400 mb-3">
                  {metric.value}
                </div>
                <h3 className="text-lg font-bold text-white mb-3">{metric.label}</h3>
                <p className="text-sm text-gray-400 leading-relaxed">{metric.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
